import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "list-extra-option" }
const _hoisted_2 = { style: {"font-size":"12px","margin-bottom":"4px"} }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "no-mb" }
const _hoisted_5 = { style: {"font-size":"12px","font-weight":"400"} }




export default /*#__PURE__*/_defineComponent({
  __name: 'ListExtraOption',
  props: {
    option: null
  },
  setup(__props: any) {

const props = __props as { option: { id:number, external_ref:string, name:string|null, text_sales:string|null, price:number, vat_rate:number } };



return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_divider = _resolveComponent("a-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_row, { class: "no-mb" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 24 }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_2, "Optie nr. " + _toDisplayString(props.option.external_ref), 1),
            _createElementVNode("h4", null, _toDisplayString(props.option.name), 1),
            _renderSlot(_ctx.$slots, "subtitle"),
            _createElementVNode("div", {
              style: {"margin-bottom":"8px"},
              innerHTML: props.option.text_sales
            }, null, 8, _hoisted_3),
            _renderSlot(_ctx.$slots, "images"),
            _createElementVNode("p", _hoisted_4, "€" + _toDisplayString(props.option.price.toLocaleString('nl-NL')), 1),
            _createElementVNode("p", _hoisted_5, "incl. " + _toDisplayString(props.option.vat_rate) + "% BTW", 1),
            _renderSlot(_ctx.$slots, "buttons")
          ]),
          _: 3
        })
      ]),
      _: 3
    }),
    _createVNode(_component_a_divider)
  ]))
}
}

})